import Box from "@/components/Box"
import css from "@styled-system/css"
import styled from "@emotion/styled"

export const Container = styled(Box)`
  ${css({
    maxWidth: ["unset", 768, 1128],
    mx: "auto",
    my: 0,
    px: ["20px", null, 3],
  })}
`
